import config from '../config.js'

import axios from 'axios'

function pingCurrentUsage(sessionId) {
  axios
    .get(config.apiServer + '/api/v3/web/current-usage?sid=' + sessionId, {})
    .then(
      response => {
        const json = response.data

        if (json.key === 'OK') {
          //console.log('Current usage logged successfully')
        } else {
          //console.log('Failed to log current usage')
        }
      },
      error => {
        //console.log('Failed to log current usage')
      }
    )
}

export function logCurrentUsage(sessionId) {
  //console.log('Logging in progress...');

  // We just loaded the app, ping now
  pingCurrentUsage(sessionId)

  // Ping every 20 minutes from now on
  setInterval(function() {
    pingCurrentUsage(sessionId)
  }, 20 * 60 * 1000)
}

function pingDailyUsage(sessionId) {
  const timezoneOffset = new Date().getTimezoneOffset() * 1000 * 60 * -1

  let data = JSON.stringify({
    sessionId: sessionId,
    timeZoneOffsetMillis: timezoneOffset
  })

  axios
    .post(config.apiServer + '/api/v3/web/usage', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(
      response => {
        const json = response.data

        if (json.key === 'OK') {
          // console.log('Daily usage logged successfully')
        } else {
          // console.log('Failed to log daily usage')
        }
      },
      error => {
        // console.log('Failed to log daily usage')
      }
    )
}

export function logDailyUsage(sessionId) {
  //console.log('Logging in progress...');

  // We just loaded the app, ping now
  pingDailyUsage(sessionId)

  // Calculate the time until midnight
  const now = new Date()
  let timeToMidnight =
    new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0) -
    now // Date + 1 is for tomorrow's midnight

  if (timeToMidnight < 0) {
    timeToMidnight += 86400000 // It's too close to midnight, ping tomorrow.
  }

  // Wait until midnight to ping again, then ping every midnight after that
  setTimeout(function() {
    pingDailyUsage(sessionId)

    // Ping every 24 hours afterwards
    setInterval(function() {
      pingDailyUsage(sessionId)
    }, 24 * 60 * 60 * 1000)
  }, timeToMidnight)
}



// WEBPACK FOOTER //
// ./src/Helpers/logging.js